import React from 'react';
import { Route } from 'react-router-dom';
import UgcSection from '../pages/ugc/UgcSection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const ugcRoutes = (
    <Route
        path="/ugc/section"
        element={
            <ProtectedRoute requiredPermission="settings.ugc.view">
                <UgcSection />
            </ProtectedRoute>
        }
    />
);

export default ugcRoutes;
